export default {
  category: 'book',
  name: 'The Paradox of Choice',
  author: 'Barry Shwartz',
  date: '4/22/25',
  path: '/notes/the-paradox-of-choice',
  photo: 'https://twos.s3.amazonaws.com/parkerklein/parker-klein-the-paradox-of-choice-barry-shwartz.jpg',
  tags: ['Business', 'Leadership', 'Management', 'Self-help', 'Psychology'],
  time: 27,
  rating: 6.8,
  review: '',
  link: 'https://www.amazon.com/Paradox-Choice-Why-More-Less/dp/0060005696',
  mediumLink: '',
  patreonLink: '',
  // podcastLink: 'https://anchor.fm/parkerklein/episodes/',
  // podcastEmbed: 'https://anchor.fm/parkerklein/embed/episodes/',
  // youtubeLink: 'https://youtu.be/',
  twosLink: 'https://www.twosapp.com/659ca6ed98ecf8af93cdf5ff',
  // youtubeEmbed: 'https://www.youtube.com/embed/',
  releaseDate: '',
};
